import { Controller } from "@hotwired/stimulus"

/**
 * Ui::Observability::WaterfallComponent's selection controller.
 *
 * Entirely self-contained within one component instance — every target is
 * scoped to this controller's own root element, so it never depends on
 * ActionCable, another controller, or a page-level id. That's deliberate:
 * this same markup renders identically in Lookbook and in a real page,
 * which is the whole point of building it as a standalone component first.
 */
export default class extends Controller {
  static targets = ["row", "panel"]

  select(event) {
    const index = event.currentTarget.dataset.index
    if (index === undefined) return

    for (const row of this.rowTargets) {
      row.dataset.active = row.dataset.index === index ? "true" : "false"
    }
    for (const panel of this.panelTargets) {
      panel.classList.toggle("hidden", panel.dataset.index !== index)
    }
  }
}
